import * as React from 'react'
import { PressableProps, Text } from 'react-native'
import { FontAwesomeIcon, FontAwesomeIconProps } from '@purposity/icons'
import { BaseCircleButton, styles } from '@components/Buttons/BaseCircleButton'
import * as Colors from '@themes/Colors'

type Props = {
  flavor: 'default' | 'primary' | 'secondary'
  icon: FontAwesomeIconProps['icon']
} & Omit<PressableProps, 'children'>

export function CircleButton(
  { flavor, icon, ...props }: Props = { flavor: 'default', icon: '0' }
) {
  const buttonStyles =
    flavor === 'primary'
      ? styles.buttonAltPrimary
      : flavor === 'secondary'
      ? styles.buttonAltGray
      : undefined

  const iconColor =
    flavor === 'primary'
      ? Colors.white
      : flavor === 'secondary'
      ? Colors.abbyGray
      : Colors.textGray
  return (
    <BaseCircleButton buttonStyles={[styles.button, buttonStyles]} {...props}>
      <Text style={{ fontSize: 24 }}>
        <FontAwesomeIcon icon={icon} color={iconColor} />
      </Text>
    </BaseCircleButton>
  )
}
